import React from 'react';
import { Button, List, Panel, Typography } from '@icecreamsocial/components';

/**
 *
 * @param {SubscriptionOptionProps} props
 * @returns
 */
export const SubscriptionOption = ({
	loading = false,
	unsubscribed = false,
	error = null,
	heading,
	label,
	value,
	ctaText,
	onUnsubscribe,
	onResubsribe,
}) => {
	return (
		<Panel shadow='default' border='none' marginBottom='md'>
			<Panel.Body>
				<Typography.H2>{heading}</Typography.H2>
				<List as='dl' bullets='none'>
					<List.Item as='dt'>{label}</List.Item>
					<List.Item as='dd' typoWeight='bold' marginLeft='0'>
						{value}
					</List.Item>
				</List>
				{!unsubscribed ? (
					<Button
						backgroundColor='accent'
						textColor='bodyInverse'
						onClick={onUnsubscribe}
						disabled={loading}
					>
						{ctaText}
					</Button>
				) : (
					<>
						<Typography.Span textColor='goodDark'>
							You have successfully unsubscribed!
						</Typography.Span>
					</>
				)}
				{error && (
					<Typography.Span textColor='bad' display='block' marginTop='md'>
						{error}
					</Typography.Span>
				)}
			</Panel.Body>
		</Panel>
	);
};
